import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { Button } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  icon: string;
  label: string;
  isActive: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const SidebarGenericButton: React.FC<IParams> = ({
  icon,
  label,
  isActive,
  onClick,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme, companyTheme } = rootStore.commonStore;
  const { isMobileMediaQuery } = rootStore.responsiveStore;
  const{canViewODG}=rootStore.tenantStore

  // const getIconClasses = () => {
  //   const iconColor = isActive
  //     ? theme!.sidebarSelectedButton
  //     : theme!.sidebarBorder;
  //   return `text-${iconColor}`;
  // };

  const getIconClasses = () => {
    // modificato per i nuovi css personalizzati esternamente
      if(isActive)
          return `${theme!.sidebarSelectedButton}`;
          else
          return `${theme!.sidebarBorder}`;
    };
  

  const getBorderClasses = () => {
    switch (companyTheme!.sidebarButtonBorder) {
      case "rounded":
        return "sidebarButton-rounded";
      case "squared":
        return "sidebarButton-squared";
      default:
        break;
    }
  };

  return (
    <>
       <Button
        className={classNames(isMobileMediaQuery?
          "sidebarMobileButton" : "col-10",
          "sidebarButton",
          getBorderClasses(), //bordi
          getIconClasses() //colore icona interiore
        )}
        color=""
        onClick={onClick}
      >
        <div className="">
          <i className={icon}></i>
          <h6 className="font-size-80 mb-0 sidebarButtonText">{label}</h6>
        </div>
      </Button>
    </>
  );
};

export default observer(SidebarGenericButton);
